export default "__VITE_ASSET__557e743b__"